/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type TriggerRiskAnalysisRequestBody = {
  /**
   * The policy ID.
   */
  id: string;
  /**
   * Cap the backfill at the most recent N unanalyzed messages. Defaults to 100 (the recent-N drain budget). Pass 0 to request a full backfill of every unanalyzed message.
   */
  limit?: number | undefined;
};

/** @internal */
export type TriggerRiskAnalysisRequestBody$Outbound = {
  id: string;
  limit: number;
};

/** @internal */
export const TriggerRiskAnalysisRequestBody$outboundSchema: z.ZodMiniType<
  TriggerRiskAnalysisRequestBody$Outbound,
  TriggerRiskAnalysisRequestBody
> = z.object({
  id: z.string(),
  limit: z._default(z.int(), 100),
});

export function triggerRiskAnalysisRequestBodyToJSON(
  triggerRiskAnalysisRequestBody: TriggerRiskAnalysisRequestBody,
): string {
  return JSON.stringify(
    TriggerRiskAnalysisRequestBody$outboundSchema.parse(
      triggerRiskAnalysisRequestBody,
    ),
  );
}
